import * as moment from 'moment'
import IChild from 'types/database/children/child'
import { IStorageData } from './types'

export const CHECK_FOR_NEW_ASSESMENT_GAP = [3, 'months']

// const checkForNewAssessmentLog = (...args) =>
//   console.log('[checkForNewAssessment]', ...args)

/**
 * checks if new assessment is available
 * @param currentPatient `IChild` extended
 * by `patientId` and any other data
 * @returns `true` only once in a session
 */
export const checkForNewAssessment = (
  currentPatient:
    | ({ [key: string]: any; patientId: string } & IChild)
    | null
    | undefined,
  storageData: IStorageData,
  callback?: (storageData: IStorageData) => void
): boolean => {
  // const log = checkForNewAssessmentLog
  let status = false

  // history-mode: 3-months-check
  if (currentPatient) {
    const storageObj: IStorageData = {}

    if (storageData) {
      Object.assign(storageObj, storageData)
      // log('updated storageObj', storageObj)
    }

    // create patient if not exist
    if (!storageObj[currentPatient.patientId]) {
      storageObj[currentPatient.patientId] = {}
    }

    // return if it was already checked
    if (storageObj[currentPatient.patientId].checked) {
      // log('returned checked')
      return status
    }

    // * check
    const nextAssessmentTime = moment
      .unix(currentPatient.assessments.relevant_assessment)
      .add(...CHECK_FOR_NEW_ASSESMENT_GAP)
    const diff = nextAssessmentTime.diff(moment())

    if (diff < 0) {
      status = true
    }

    // * storageData update
    storageObj[currentPatient.patientId].checked = true

    if (typeof callback === 'function') {
      callback(Object.assign({}, storageObj))
    }
  } else {
    // log('returned without currentPatient')
    return status
  }

  // log('returned status', status)
  return status
}

export const getTimeForNewAssessment = (relevantAssessment: number): string => {
  const nextAssessmentTime = moment
    .unix(relevantAssessment)
    .add(...CHECK_FOR_NEW_ASSESMENT_GAP)

  const timeLeftD = nextAssessmentTime.diff(moment(), 'days')

  return `${timeLeftD < 0 ? 0 : timeLeftD} days`
}



// WEBPACK FOOTER //
// ./src/services/historyMode/historyMode.ts